import axios from "axios";
import router from "@/router";

const service = axios.create({
  baseURL: `${process.env.VUE_APP_BRAND_CHANNEL_VIVO_API_ENDPOINT}`,
});

service.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    // TODO: registrar no Rollbar!
    if (!error.response) {
      // eslint-disable-next-line prettier/prettier
    } else if (error.response.status === 404) {
      router.push({ name: "pageNotFound" });
      return Promise.reject(error);
    } else if (error.response.status >= 500) {
      router.push({ name: "pageNotFound" });
      return Promise.reject(error);
    }
  }
);

export default service;
